import { defineComponent as h, computed as l, openBlock as o, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as n, createStaticVNode as v } from "vue";
const p = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "f67190cc-fa1e-4906-9938-24bdf73cd243" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#f67190cc-fa1e-4906-9938-24bdf73cd243)" }, k = { key: 0 }, u = /* @__PURE__ */ v('<path fill="#eee" d="M0 0h512v512H0z"></path><path fill="#496e2d" d="M256 32a206 206 0 1 0 0 412 206 206 0 0 0 0-412zm0 8a198 198 0 0 1 182 276h-43a158 158 0 0 0-73-222v8a151 151 0 0 1 64 214h-1v72a197 197 0 0 1-258 0v-72a151 151 0 0 1 63-214v-8a159 159 0 0 0-73 222H74A198 198 0 0 1 256 40zm0 12A186 186 0 0 0 73 271a8 8 0 0 0 9 7 8 8 0 0 0 7-9l-3-31a170 170 0 1 1 337 31 8 8 0 0 0 7 9 8 8 0 0 0 9-7A187 187 0 0 0 256 52zM63 355a8 8 0 0 0-4 1 8 8 0 0 0-3 11 238 238 0 0 0 400 0 8 8 0 0 0-3-11 8 8 0 0 0-11 3 222 222 0 0 1-372 0 8 8 0 0 0-7-4z"></path><path fill="#ffda44" d="M199 86v51l-25 153-38 31h240l-38-31-25-153V86H199z"></path><path fill="#ff9811" d="M136 321h240v24H136z"></path><path fill="#eee" d="M136 345h240v24H136z"></path><path fill="#6da544" d="M136 369h240v24H136z"></path><circle cx="191" cy="357" r="8" fill="#0052b4"></circle><circle cx="-321" cy="357" r="8" fill="#0052b4" transform="scale(-1 1)"></circle><path fill="#d80027" d="M256 252a20 20 0 0 0-20 20 20 20 0 0 0-17-10 20 20 0 0 0-20 20 20 20 0 0 0 20 20 20 20 0 0 0 3 0v71h-1c-5 0-10 4-10 10v8c0 5 5 10 10 10h1v1c0 6 5 10 10 10h48c6 0 10-4 10-10v-1h1c6 0 10-5 10-10v-8c0-6-4-10-10-10h-1v-71a20 20 0 0 0 3 0 20 20 0 0 0 20-20 20 20 0 0 0-20-20 20 20 0 0 0-17 11 20 20 0 0 0 0-1 20 20 0 0 0-20-20z"></path>', 9), g = { fill: "none" }, z = ["r"], w = /* @__PURE__ */ h({
  __name: "in-tn",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, a = l(() => 512 + 2 * e.strokeWidth), c = l(() => -e.strokeWidth), s = l(() => 256 + e.strokeWidth / 2);
    return (x, y) => (o(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${a.value} ${a.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (o(), i("title", k, d(e.flagName), 1)) : f("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: s.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, p));
  }
});
export {
  w as default
};
//# sourceMappingURL=in-tn-b8bf50ca.js.map
